import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import productSlice from './slices/productSlice';
import saidaProductSlice from './slices/saidaProductSlice';
import categoriaSlice from './slices/getCategoria';
import entradaSlice from './slices/entradaProductSlice';
import arvoreSlice from './slices/arvoreSlice';
import navBarSlice from './slices/menubarSlice';
import horasSlice from './slices/horasSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    product: productSlice,
    saidaProduct: saidaProductSlice,
    categorias: categoriaSlice,
    entrada: entradaSlice,
    arvore: arvoreSlice,
    navBar: navBarSlice,
    horas: horasSlice,
  },
});
